import { createStore } from "vuex";

export default createStore({
  state() {
    return {
      token: "",
      username: "",
      authority: false,
    };
  },
  getters: {
    token: (state) => state.token,
    username: (state) => state.username,
    authority: (state) => state.authority,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsername(state, username) {
      state.username = username;
    },
    setAuthority(state, authority) {
      state.authority = authority;
    },
  },
});
